'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// @class ItakoAudioReaderAudioElement

var ItakoAudioReaderAudioElement = function () {
  /**
  * @constructor
  * @param {string} type - a target token type
  * @param {object} [options={}] - a token default options
  */

  function ItakoAudioReaderAudioElement() {
    var type = arguments.length <= 0 || arguments[0] === undefined ? 'audio' : arguments[0];
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    _classCallCheck(this, ItakoAudioReaderAudioElement);

    this.name = 'audio-element';
    this.type = type;
    this.opts = _extends({
      volume: 1,
      pitch: 1
    }, options);

    this.enableAudioElement();

    this.audios = [];
  }

  /**
  * monky patching for iOS (untested)
  * @see http://qiita.com/uupaa/items/e5856e3cb2a9fc8c5507
  * @see https://github.com/beraboume/nicolive.berabou.me/blob/master/app/services/sound-enabler.coffee
  * @returns {undefined}
  */


  _createClass(ItakoAudioReaderAudioElement, [{
    key: 'enableAudioElement',
    value: function enableAudioElement() {
      if (typeof window === 'undefined') {
        return;
      }

      window.addEventListener('touchstart', function enable() {
        window.removeEventListener('touchstart', enable);

        // use brfs/transform-loader (see https://github.com/webpack/transform-loader#readme)
        var buffer = Buffer("SUQzAwAAAAADBVRBTEIAAAABAAAAVENPTgAAAAEAAABUSVQyAAAAAQAAAFRQRTEAAAABAAAAVFJDSwAAAAEAAABUWUVSAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//uQxAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAACcQCAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA//////////////////////////////////////////////////////////////////8AAAAeTEFNRTMuOTlyBJwAAAAALf4AADUgJAZAIQABrgAAAnEoRCdbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//sQxAADwAABpAAAACAAADSAAAAETEFNRTMuOTkuNVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVX/+xDEKYPAAAGkAAAAIAAANIAAAARVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVRBRwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/","base64");
        this.play('data:audio/mpeg;base64,' + buffer.toString('base64'));
      });
    }

    /**
    * @method read
    * @param {token} token - a itako-token instance
    * @returns {promise|token} - returns the promise only when reading
    */

  }, {
    key: 'read',
    value: function read(token) {
      if (token.type !== this.type) {
        return token;
      }

      return this.play(token.meta.preload || token.value.url || token.value, token.options).then(function (audio) {
        return token.setMeta('audio', audio);
      });
    }

    /**
    * @method createAudio
    * @param {token} token - a itako-token instance
    * @returns {boolean} - returns true if preloaded
    */

  }, {
    key: 'preload',
    value: function preload(token) {
      if (token.type !== this.type) {
        return false;
      }

      token.setMeta('preloadStart', Date.now());
      token.setMeta('preload', this.createAudio(token.value.url || token.value));
      token.meta.preload.then(function () {
        token.setMeta('preloadEnd', Date.now());
      });
      return true;
    }

    /**
    * @method createAudio
    * @param {string} url - an audio url
    * @returns {promise<audio>} - returns audio instance
    */

  }, {
    key: 'createAudio',
    value: function createAudio(url) {
      return new _bluebird2.default(function (resolve, reject) {
        var audio = new Audio();
        audio.src = url;

        audio.addEventListener('canplaythrough', function () {
          return resolve(audio);
        });
        audio.addEventListener('error', function (event) {
          return reject(event.target.error);
        });
      });
    }

    /**
    * @method play
    * @param {string|promise} url - an audio url or promise
    * @param {object} [options={}] - a gain/playbackRate options
    * @returns {promise} - returns the used nodes after playing
    */

  }, {
    key: 'play',
    value: function play(url) {
      var _this = this;

      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

      var canplaythrough = url instanceof _bluebird2.default ? url : this.createAudio(url);
      return canplaythrough.then(function (audio) {
        return new _bluebird2.default(function (resolve) {
          audio.volume = options.volume || 1;
          audio.playbackRate = options.pitch || options.speed || 1;
          audio.play();
          audio.addEventListener('ended', function () {
            var index = _this.audios.indexOf(audio);
            if (index > -1) {
              _this.audios.splice(index, 1);
            }

            resolve(audio);
          });

          _this.audios.push(audio);
        });
      });
    }
  }]);

  return ItakoAudioReaderAudioElement;
}();

exports.default = ItakoAudioReaderAudioElement;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 0
 ** module chunks = 0
 **/